// extracted by mini-css-extract-plugin
export var bgDark = "PageHeaderComponent-module--bg-dark--3yBNK";
export var container = "PageHeaderComponent-module--container--38zOM";